import './App.css';
import AppRouter from "./AppRouter";

function App() {
  return (
    <div>
      <AppRouter/>
    </div>
  );
}

export default App;
